import { useQuery } from "@tanstack/react-query";
import {
  RENTALS_LONG_STALE_TIME,
  RENTALS_QUERY_KEYS,
} from "@/features/rentals/configs/rentalsQueryKeys.config";
import {
  getRentalCollection,
  getRentalCollections,
} from "@/features/rentals/services/rentals.service";

type UseRentalCollectionsOptions = { enabled?: boolean };

export const useRentalCollections = (options?: UseRentalCollectionsOptions) => {
  return useQuery({
    queryKey: RENTALS_QUERY_KEYS.collections,
    queryFn: () => getRentalCollections(),
    staleTime: RENTALS_LONG_STALE_TIME,
    enabled: options?.enabled ?? true,
  });
};

export const useRentalCollection = (collectionId: string | undefined) => {
  return useQuery({
    queryKey: RENTALS_QUERY_KEYS.collection(collectionId),
    queryFn: () => (collectionId ? getRentalCollection(collectionId) : Promise.resolve(null)),
    enabled: Boolean(collectionId),
    staleTime: RENTALS_LONG_STALE_TIME,
  });
};
